module.exports = __webpack_public_path__ + "img/pic_add.16c07012.png";